import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  width: 100%;
  margin-bottom: 36px;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    margin-bottom: 18px;
  }
`;

export const Title = styled.div`
  display: flex;
  font-family: "OpenSansRegular";
  font-size: 48px;
  font-weight: 300;
  color: ${colors.orange1};
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 1100px;
    margin-bottom: 25px;
    font-size: 36px;
  }
`;

export const Description = styled.div`
  display: flex;
  width: 1600px;
  font-family: "OpenSandRegular";
  font-size: 24px;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.gray6};
  @media (max-width: 1400px) {
    width: 1100px;
    font-size: 16px;
  }
`;
